<template>
  <asd20-app-template
    :back-link="computedBackLink"
    :title="annualCalendarTitle"
    back-label="Back"
    icon="calendar"
    role="main"
  >
    <template v-slot:toolbar-start>
      <!-- <asd20-button
        v-if="!isMobile"
        label="Print"
        icon="printer"
        size="sm"
        centered
        horizontal
        bordered
        @click.native="printGuideOpen = true"
      /> -->
      <asd20-button
        v-if="selectedOrganization && selectedOrganization.abbreviation !== 'ASD20'"
        :link="pdfDownloadLink"
        class="pdf-button"
        label="Download PDF"
        icon="files"
        size="sm"
        centered
        horizontal
        bordered
      />
      <asd20-button
        v-if="
          selectedOrganization &&
            selectedOrganization.abbreviation === 'ASD20' &&
            selectedAnnualYear === 2024
        "
        link="https://asd20websitestorage.blob.core.windows.net/website-files/Academy-District-20/ASD20%202024-25%20Annual%20Calendar.pdf"
        class="pdf-button"
        label="Download PDF"
        icon="files"
        size="sm"
        centered
        horizontal
        bordered
      />
      <asd20-button
        v-if="
          selectedOrganization &&
            selectedOrganization.abbreviation === 'ASD20' &&
            selectedAnnualYear === 2025
        "
        link="https://asd20websitestorage.blob.core.windows.net/website-files/Academy-District-20/ASD20%202025-26%20Annual%20Calendar.pdf"
        class="pdf-button"
        label="Download PDF"
        icon="files"
        size="sm"
        centered
        horizontal
        bordered
      />
      <asd20-button
        v-if="
          selectedOrganization &&
            selectedOrganization.abbreviation === 'ASD20' &&
            selectedAnnualYear === 2026
        "
        link="https://asd20websitestorage.blob.core.windows.net/website-files/Academy-District-20/ASD20%202026-27%20Annual%20Calendar.pdf"
        class="pdf-button"
        label="Download PDF"
        icon="files"
        size="sm"
        centered
        horizontal
        bordered
      />
    </template>

    <template v-slot:default>
      <div
        ref="printContent"
        class="print-wrapper">
        <div class="title-and-logo">
          <h1 class="main-title">{{ annualCalendarTitle }}</h1>
          <div
            v-if="
              selectedOrganization &&
                ![
                  'Academy District 20',
                  'Academy District 20 Insider',
                ].includes(selectedOrganization.title)
            "
            class="print-logo"
          >
            <img
              v-if="selectedOrganization.logoImageUrl"
              :src="selectedOrganization.logoImageUrl"
              :alt="`${selectedOrganization.title} logo`"
              class="print-logo__image"
            >
            <div class="print-logo__title">
              {{ mapOrganizationTitle }}
              <small v-if="mapOrganizationSubtitle">{{
                mapOrganizationSubtitle
              }}</small>
            </div>
          </div>

          <asd20-district-logo
            v-if="
              selectedOrganization &&
                ['Academy District 20', 'Academy District 20 Insider'].includes(
                  selectedOrganization.title
                )
            "
          />
        </div>
        <asd20-annual-calendar
          v-if="selectedOrganization && annualEvents.length"
          :events="annualEvents"
          :start-year="selectedAnnualYear"
          :poster-mode="false"
          :selected-organization="selectedOrganization"
        />
      </div>
      <asd20-modal
        :open="printGuideOpen"
        class="print-guide"
        title="Print Guide"
        dismissable
        windowed
        @dismiss="printGuideOpen = false"
      >
        <asd20-viewport
          class="print-guide-viewport"
          scrollable
          padded>
          <p>
            If you're printing a landscape 8.5 x 11 page, we recommend that you close
            this window and use the <b>"Download PDF"</b> button instead. You'll get a
            pre-formatted PDF file that will print well on any printer.
          </p>
          <p>
            Use the "Print" button below if you need a custom size or orientation.
          </p>
          <p>
            Browsers can have different print engines and settings that will make
            the same document print differently. Use these settings for best results:
            <ul>
              <li><b>Turn on</b> "Background Graphics"</li>
              <li><b>Turn off</b> "Headers and Footers"</li>
              <li>Depending on the orientation you'd like to print, you may need to
              adjust the "Scale" setting to get the content to fit on a single page.
              </li>
              <li>Your browser's settings may differ from those listed above.</li>
            </ul>
          </p>
          <asd20-button
            v-if="!isMobile"
            label="Print"
            icon="printer"
            size="sm"
            centered
            horizontal
            bordered
            @click.native="printStandard"
          />
        </asd20-viewport>
      </asd20-modal>
    </template>
  </asd20-app-template>
</template>

<script>
import Asd20AnnualCalendar from '../../components/organisms/Asd20AnnualCalendar'
import Asd20AppTemplate from '@asd20/ui/src/components/templates/Asd20AppTemplate'
import Asd20DistrictLogo from '@asd20/ui/src/components/atoms/Asd20DistrictLogo'
import Asd20Logo from '@asd20/ui/src/components/atoms/Asd20Logo'
import Asd20Modal from '@asd20/ui/src/components/molecules/Asd20Modal'
import Asd20Viewport from '@asd20/ui/src/components/atoms/Asd20Viewport'

export default {
  name: 'AnnualCalendarPage',

  components: {
    Asd20AnnualCalendar,
    Asd20AppTemplate,
    Asd20DistrictLogo,
    Asd20Logo,
    Asd20Modal,
    Asd20Viewport,
  },

  data() {
    return {
      localAnnualEvents: [],
      selectedAnnualYear: 2024,
      printGuideOpen: false,
      includedOrganizationIds: [],
      calendarKey: [
        { label: 'District Closed', color: '#E8350F' },
        { label: 'No Students', color: '#FFD700' },
        { label: 'No Middle School Students', color: '#CB78F1' },
        { label: 'No Elementary School Students', color: '#ADD8E6' },
        { label: 'PLC 2-Hour Late Start', color: '#79EB73' },
        { label: 'Other Events', color: '#105AC9' },
      ],
      highSchoolAbbreviations: ['aahs', 'dcchs', 'lhs', 'pchs', 'rhs'],
      isReady: false,
    }
  },

  computed: {
    selectedOrganization() {
      return this.$store.getters.selectedOrganization || {}
    },
    computedBackLink() {
      const referrer = this.$route.query.referrer

      if (
        referrer &&
        referrer.includes('asd20.org') &&
        !referrer.includes('calendar.asd20.org')
      ) {
        return referrer
      }

      if (this.selectedOrganization && this.selectedOrganization.abbreviation) {
        return `https://calendar.asd20.org/${this.selectedOrganization.abbreviation.toLowerCase()}`
      }

      return 'https://calendar.asd20.org'
    },
    mapOrganizationTitle() {
      if (
        this.selectedOrganization &&
        this.selectedOrganization.title
      ) {
        return this.selectedOrganization.title
          .replace(
            /\b(Elementary School|Elementary-Middle School|Middle School|Middle-High School|High School|Elementary-Middle-High School)/g,
            ''
          )
          .trim()
      }
      return ''
    },

    mapOrganizationSubtitle() {
      if (
        this.selectedOrganization &&
        this.selectedOrganization.title
      ) {
        const match = this.selectedOrganization.title.match(
          /\b(Elementary School|Elementary-Middle School|Middle School|Middle-High School|High School|Elementary-Middle-High School)/g
        )
        return match ? match.join('') : ''
      }

      return ''
    },
    isMobile() {
      return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
    },
    annualEvents() {
      const events = this.localAnnualEvents.length
        ? this.localAnnualEvents
        : this.$store.state.annualEvents

      return events.map(e => ({
        ...e,
        start: e.start || null,
        end: e.end || null,
        calendarColor: this.classifyEventColor(e.summary, e.calendarColor),
      }))
    },
    annualCalendarTitle() {
      if (!this.selectedAnnualYear) return 'Annual Calendar'

      const nextYear = this.selectedAnnualYear + 1
      const shortNextYear = nextYear.toString().slice(-2)

      let abbreviation = ''

      if (
        this.selectedOrganization &&
        this.selectedOrganization.abbreviation &&
        this.selectedOrganization.abbreviation.toLowerCase() !== 'asd20' &&
        this.highSchoolAbbreviations.includes(
          this.selectedOrganization.abbreviation.toLowerCase()
        )
      ) {
        abbreviation = `${this.selectedOrganization.abbreviation} `
      }
      console.log('Abbreviation from Calendar Title:', abbreviation)

      return `${abbreviation}${this.selectedAnnualYear}-${shortNextYear} Annual Calendar`
    },
    pdfDownloadLink() {
      const links = {
        aahs:
          'https://asd20websitestorage.blob.core.windows.net/website-files/Air-Academy-High-School/AAHS%202024-25%20Annual%20Calendar.pdf',
        dcchs:
          'https://asd20websitestorage.blob.core.windows.net/website-files/Discovery-Canyon-Campus-High-School/DCCHS%202024-25%20Annual%20Calendar.pdf',
        lhs:
          'https://asd20websitestorage.blob.core.windows.net/website-files/Liberty-High-School/LHS%202024-25%20Annual%20Calendar.pdf',
        pchs:
          'https://asd20websitestorage.blob.core.windows.net/website-files/Pine-Creek-High-School/PCHS%202024-25%20Annual%20Calendar.pdf',
        rhs:
          'https://asd20websitestorage.blob.core.windows.net/website-files/Rampart-High-School/RHS%202024-25%20Annual%20Calendar.pdf',
        vhs:
          'https://asd20websitestorage.blob.core.windows.net/website-files/VHS/VHS%202024-25%20Annual%20Calendar.pdf',
      }

      let key = ''

      if (
        this.selectedOrganization &&
        this.selectedOrganization.abbreviation
      ) {
        key = this.selectedOrganization.abbreviation.toLowerCase()
      }

      return links[key] || ''
    },
  },
  beforeRouteEnter(to, from, next) {
    console.log('beforeRouteEnter → to:', to)
    console.log('beforeRouteEnter → from:', from)

    next(async vm => {
      const { abbreviation, year } = to.params
      const highSchools = ['aahs', 'dcchs', 'lhs', 'pchs', 'rhs', 'vhs']

      console.log('Route params → abbreviation:', abbreviation, 'year:', year)

      // Step 1: Wait for organizations and calendar subscriptions
      await vm.$store.dispatch('getOrganizations')
      await vm.$store.dispatch('getCalendarSubscriptions')
      console.log('Organizations:', vm.$store.state.organizations)
      console.log('Calendar Subscriptions:', vm.$store.state.calendarSubscriptions)

      // Step 2: Find org by abbreviation
      const org = vm.$store.state.organizations.find(
        o => o.abbreviation.toLowerCase() === (abbreviation || '').toLowerCase()
      )

      if (org) {
        console.log('Found organization:', org)
        await vm.$store.commit('SET_SELECTED_ORGANIZATION_ID', org.id)
      } else {
        console.log('No High School organization found. Setting organization to', abbreviation)
        await vm.$store.commit('SET_SELECTED_ORGANIZATION_ID', '26eaf390-d8ab-11e9-a3a8-5de5bba4f125')

      }

      if (abbreviation && highSchools.includes(abbreviation.toLowerCase())) {
        console.log(`This is a High School calendar for: ${abbreviation}`)
        const highSchoolCalendarMap = {
          aahs: {
            orgId: 'bb6e9cd6-da25-9e6f-5e8d-072b9a7df4f0',
            organizationIds: [
              '26eaf390-d8ab-11e9-a3a8-5de5bba4f125',
              'bb6e9cd6-da25-9e6f-5e8d-072b9a7df4f0',
            ],
            calendarIds: [
              '2002ca04-bd3b-dd84-1e4e-576d878dd497',
              '38e42670-b6eb-11ee-b0fb-99183002509c',
              '819c3bb0-ddf1-11ed-a03d-ebc4dcfd7207',
            ],
          },
          dcchs: {
            orgId: 'f4656914-9ec6-1811-aa5d-31f532f483d5',
            organizationIds: [
              '26eaf390-d8ab-11e9-a3a8-5de5bba4f125',
              'f4656914-9ec6-1811-aa5d-31f532f483d5',
            ],
            calendarIds: [
              '2002ca04-bd3b-dd84-1e4e-576d878dd497',
              '38e42670-b6eb-11ee-b0fb-99183002509c',
              '11ed8bb0-f627-11eb-8439-03579247c930',
            ],
          },
          lhs: {
            orgId: 'a6f3a682-acf0-909b-96d5-e840e6a44eb5',
            organizationIds: [
              '26eaf390-d8ab-11e9-a3a8-5de5bba4f125',
              'a6f3a682-acf0-909b-96d5-e840e6a44eb5',
            ],
            calendarIds: [
              '2002ca04-bd3b-dd84-1e4e-576d878dd497',
              '38e42670-b6eb-11ee-b0fb-99183002509c',
              '743a45b0-3f46-11ed-9802-fb3267a9cff1',
            ],
          },
          pchs: {
            orgId: '3ace095e-c792-6fa8-3299-a0db26db81dd',
            organizationIds: [
              '26eaf390-d8ab-11e9-a3a8-5de5bba4f125',
              '3ace095e-c792-6fa8-3299-a0db26db81dd',
            ],
            calendarIds: [
              '2002ca04-bd3b-dd84-1e4e-576d878dd497',
              '38e42670-b6eb-11ee-b0fb-99183002509c',
              '976fba20-556e-11ef-ad99-1f3e57e66b91',
            ],
          },
          rhs: {
            orgId: '2a47254c-89ad-ce5e-156b-e44bec9452d1',
            organizationIds: [
              '26eaf390-d8ab-11e9-a3a8-5de5bba4f125',
              '2a47254c-89ad-ce5e-156b-e44bec9452d1',
            ],
            calendarIds: [
              '2002ca04-bd3b-dd84-1e4e-576d878dd497',
              '38e42670-b6eb-11ee-b0fb-99183002509c',
              'baa2e970-3902-11ed-b83b-470c3a248522',
            ],
          },
          vhs: {
            orgId: 'e0f7c870-1f4d-34e2-934c-28b991f697ae',
            organizationIds: [
              '26eaf390-d8ab-11e9-a3a8-5de5bba4f125',
              'e0f7c870-1f4d-34e2-934c-28b991f697ae',
            ],
            calendarIds: [
              '2002ca04-bd3b-dd84-1e4e-576d878dd497',
              'ad641181-386a-9134-b8e0-9de31af433dd',
            ],
          },
        }
        const config = highSchoolCalendarMap[abbreviation.toLowerCase()]

        if (config) {
          const today = new Date()
          const schoolYear =
            today.getMonth() >= 6
              ? today.getFullYear()
              : today.getFullYear() - 1

          await vm.initializeAnnualCalendar(
            schoolYear,
            config.organizationIds,
            config.calendarIds
          )
        }
      } else {
        console.log('This is a District calendar.')

        const selectedYear = Number(year)
        const yearToUse = selectedYear || 2025 // Default district year

        console.log('Resolved district year:', yearToUse)

        const districtOrgId = '26eaf390-d8ab-11e9-a3a8-5de5bba4f125'
        const districtCalendarIds = [
          '2002ca04-bd3b-dd84-1e4e-576d878dd497',
          '0ff78a00-c178-11ec-a412-fd5f1ae617e2',
          'ef106e90-0b30-11ec-b38f-953cc4383d45',
          '38e42670-b6eb-11ee-b0fb-99183002509c',
        ]

        console.log('Using district org & calendars.')

        await vm.initializeAnnualCalendar(
          yearToUse,
          [districtOrgId],
          districtCalendarIds
        )
      }
    })
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyPress)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyPress)
  },

  methods: {
    async initializeAnnualCalendar(year, organizationIds, calendarIds) {
      this.selectedAnnualYear = year
      console.log('Selected Year:', year)

      this.$store.commit('SET_INCLUDED_ORGANIZATION_IDS', organizationIds)
      this.$store.dispatch('setSelectedCalendarIds', calendarIds)

      if (year === 2025) {
        console.log('Loading static JSON file for 2025')
        const response = await fetch('/data/2025-26annual.json')
        this.localAnnualEvents = await response.json()
      } else if (year === 2026) {
        console.log('Loading static JSON file for 2026')
        const response = await fetch('/data/2026-27annual.json')
        this.localAnnualEvents = await response.json()
      } else {
        this.localAnnualEvents = []
        await this.fetchAnnualData(year)
      }
    },

    async fetchAnnualData(year) {
      await this.$store.dispatch('queryAnnualEvents', year)
    },
    handleKeyPress(event) {
      if (event.key === '~' || event.key === '`') {
        this.printGuideOpen = true
      }
    },

    classifyEventColor(summary, defaultColor) {
      const classify = require('../../helpers/classifyCalendarEvent.js')
        .classifyCalendarEvent
      return classify(summary, defaultColor)
    },

    printStandard() {
      this.$nextTick(() => {
        const content = this.$el.querySelector('.print-wrapper')
        if (!content) {
          alert('Unable to find calendar content to print.')
          return
        }

        const printContent = content.innerHTML

        const styles = `
          <link rel="stylesheet" href="/static/annual-calendar-print.css">
        `
        const fontLinks = `
          <link rel="preconnect" href="https://fonts.googleapis.com">
          <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
          <link href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap" rel="stylesheet">
          <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&family=Roboto:wght@400;700&display=swap" rel="stylesheet">
          <style>
            p, span {
              font-family: 'Roboto', sans-serif;
            }
            h1, h2, h3, h4 {
              font-family: 'Montserrat', sans-serif;
            }
          </style>
        `

        const printWindow = window.open('', '_blank')
        if (!printWindow) {
          alert('Please allow pop-ups for this site to enable printing.')
          return
        }

        printWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>${this.annualCalendarTitle}</title>
            ${styles}
            ${fontLinks}
          </head>
          <body>
            <div class="annual-calendar">
              ${printContent}
            </div>
          </body>
        </html>
      `)

        printWindow.document.close()

        setTimeout(() => {
          printWindow.focus()
          printWindow.print()
          printWindow.close()
        }, 300)
      })
    },
  },
}
</script>

<style lang="scss">
.title-and-logo {
  display: none;
}
.print-wrapper {
  .asd20-district-logo,
  .print-logo {
    display: none;
  }
}
</style>

<style scoped>
.asd20-app-template {
  .asd20-modal {
    max-width: 640px !important;
    p:first-of-type {
      margin-top: space(-0.5);
    }
  }
}
::v-deep .asd20-app-template__mobile-layout {
  overflow: scroll !important;
}
::v-deep .asd20-app-template__toolbar {
  justify-content: flex-end !important;
}
@media (max-width: 768px) {
  ::v-deep .app-header__title {
    font-size: 1rem !important;
  }
}
</style>
